/**
 * @returns {Number}
 */
function randomValue() {
  const cryptoObj = window.crypto || window.msCrypto;

  if (cryptoObj) {
    const arr = new Uint32Array(1);
    cryptoObj.getRandomValues(arr);
    return arr[0] / (0xffffffff + 1); // http://brnz.org/hbr/?p=1462
  }

  return Math.random();
}

export default randomValue;
